import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";

export const fetchAppointmentsList = createAsyncThunk(
    "appointments/fetchAppointmentsList",
    async (_, { getState }) => {
        const { config, baseURL } = generateConfig();
        const response = await axios.get(
            `${baseURL}/api/appointments`,
            config
        );
        console.log("RESPONSE" + JSON.stringify(response));
        if (!response.status === 200) {
            throw new Error(
                response.data.message || "Could not fetch appointments"
            );
        }

        return response.data;
    }
);

export const fetchAppointmentsByClientId = createAsyncThunk(
    "appointments/fetchAppointmentsByClientId",
    async (clientId, { getState }) => {
        const { config, baseURL } = generateConfig();
        const response = await axios.get(
            `${baseURL}/api/appointments/clients/${clientId}`, // Use the clientId in the URL
            config
        );

        if (response.status !== 200) {
            // Check the status code for success
            throw new Error(
                response.data.message || "Could not fetch appointments"
            );
        }

        return response.data;
    }
);

export const fetchAppointmentsByClinician = createAsyncThunk(
    "appointments/fetchAppointmentsByClinician",
    async (clinicianId, { getState }) => {
        const { config, baseURL } = generateConfig();
        const response = await axios.get(
            `${baseURL}/api/appointments/clinicians/${clinicianId}`,
            config
        );

        if (response.status !== 200) {
            throw new Error(
                response.data.message ||
                    "Could not fetch appointments by clinician"
            );
        }

        return response.data;
    }
);

export const saveSoapNote = createAsyncThunk(
    "appointments/saveSoapNote",
    async ([appointment, soapNote], { getState }) => {
        const { config, baseURL } = generateConfig();
        console.log(
            `saveSoapNote appointment: ${JSON.stringify(
                appointment
            )}, soapNote: ${JSON.stringify(soapNote)}`
        );
        const response = await axios.post(
            `${baseURL}/api/appointments/saveSoap`,
            {
                appointment,
                soapNote,
            },
            config
        );
        if (response.status !== 200) {
            throw new Error(
                response.data.message || "Could not save soap note"
            );
        }

        return response.data;
    }
);

export const fetchAppointmentsByDateRange = createAsyncThunk(
    "appointments/fetchAppointmentsByDateRange",
    async ({ startDate, endDate }, { getState }) => {
        const { config, baseURL } = generateConfig();
        try {
            // Make a GET request with the start and end date parameters
            const response = await axios.post(
                `${baseURL}/api/appointments/payroll`, // Adjust the API endpoint
                {
                    startDate,
                    endDate,
                },
                config
            );

            if (response.status !== 200) {
                throw new Error(
                    response.data.message ||
                        "Could not fetch appointments by date range"
                );
            }

            return response.data;
        } catch (error) {
            console.error("Error fetching appointments by date range:", error);
            throw error;
        }
    }
);
